import { TicketControllerApi, TicketCreateRequest } from "../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../utils/utils";

type Params = {
  ticketCreateRequest: TicketCreateRequest;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const useRaiseTicket = () =>
  useMutationWithLoading(async (params: Params) =>
    new TicketControllerApi(getConfigObject()).raiseTicket(
      params.ticketCreateRequest,
      getXtenantId()
    )
  );
